import React from 'react'
import PropTypes from 'prop-types'
import DoxExplorerSortMenu from './doxExplorerSortMenu'
import DoxExplorerTitleSearchBar from './doxExplorerTitleSearchBar'

const DoxExplorerTitleSortBar = ({ tax_year, onSearch, onSelectSort, layoutType, selectedSort}) => {
    const handleSearch = (val) => {
        onSearch(val)
    }

    return tax_year ? (
            <div className='doxe-titlebar hrb-columns'>
                <DoxExplorerTitleSearchBar onSearch={handleSearch} />
                <DoxExplorerSortMenu onSelectSort={onSelectSort} layoutType={layoutType} selectedSort={selectedSort}/>
            </div>
    ) : null
}

DoxExplorerTitleSortBar.propTypes = {
    tax_year: PropTypes.number,
    onSearch: PropTypes.func,
    onSelectSort: PropTypes.func.isRequired,
    layoutType: PropTypes.string.isRequired,
    selectedSort: PropTypes.string
}   

export default DoxExplorerTitleSortBar;